<template>
  <b-modal
    id="species-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer une espèce"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
    :hide-footer="!canBeDeleted"
  >
    <div v-if="selectedSpecies !== null">
      <div v-if="canBeDeleted">
        Supprimer l'espèce "{{selectedSpecies.name}}" ?
      </div>
      <div v-else>
        L'espèce' "{{selectedSpecies.name}}" ne peut pas être supprimée car elle est associée à un ou plusieurs animaux.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'SpeciesDeleteModal',

  props: {
    selectedSpecies: Object
  },

  computed: {
    canBeDeleted() {
      if (this.selectedSpecies === null) {
        return false
      }
      return this.selectedSpecies.animalsCount === 0
    }
  },

  emits: ['didDeleteSpecies'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      let speciesName = this.selectedSpecies.name

      api
        .delete(`/species/${this.selectedSpecies.id}`)
        .then(response => {
          this.$emit('didDeleteSpecies')
          this.hideModal()
          this.successToast(`Species \"${speciesName}\" supprimé`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('species-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/species/SpeciesDeleteModal.vue